import { Supplier, SupplierProduct } from "src/interfaces/bold/product/supplier";
import { getAllBackorders, getAllPurchaseOrderDrafts, getAllPurchaseOrders, getAllSupplierProducts, getAllSuppliers, getLowOrderPoints, getLowOrderPointsById, getLowOrderPointsReferenceData, getProductPurchaseHistory, getPurchaseOrderById, getPurchaseOrderDraftById, getPurchaseOrderReferenceData, getPurchaseOrders, getSupplierById, getSupplierProductById, getSupplierProductBySku, getSupplierProductsBySupplierId, getSuppliers } from "src/utils/apiRequests";
import useGetAllPaginatedItemsLegacy, { useGetAllPaginatedItems } from "../useGetAllPaginatedItems";
import useResponse, { useResponseLegacy } from "../useResponse";

export const useSuppliers = () => {
    const { rows, status } = useResponse<any[]>({ requestFunction: getSuppliers, values: null });
    return { rows, status };
}
export const useGetAllSuppliers = () => {
    const { rows, status } = useGetAllPaginatedItems<Supplier>({
        requestFunction: getAllSuppliers,
        pageSize: 100,
        idField: "Id",
        requestValues: null,
        shouldRequest: true,
        incremental: { enabled: true },
    });
    return { rows, status };
};

export const useSuppliersById = (id: number) => {
    const [response] = useResponseLegacy<Supplier[]>(getSupplierById, { id }, true, id);
    return response;
}

export const useGetAllSupplierProducts = () => {
    return useGetAllPaginatedItemsLegacy<SupplierProduct>(getAllSupplierProducts, 1000, "SupplierAssortmentItemId");
}
export const useGetSupplierProductById = (id: number, dependecy = null) => {
    const [response] = useResponseLegacy<SupplierProduct>(getSupplierProductById, { id }, true, dependecy);
    //console.log("Supplier Product", response)
    return response;
}
export const useGetSupplierProductsByProductId = (id: number, deps?) => {
    const [response] = useResponseLegacy<SupplierProduct[]>(getSupplierProductBySku, { id }, true, deps);
    return response;
}



export const usePurchaseOrders = () => {
    const [response] = useResponseLegacy<any[]>(getPurchaseOrders);
    return response;
}

export const useGetAllPurchaseOrders = (shouldRequest = true, statusFilter=null) => {
    //const { rows, status } = useGetAllPaginatedItemsLegacy<any>(getAllPurchaseOrders, 500, "PurchaseOrderNo", null, shouldRequest);
    const { rows, status } = useGetAllPaginatedItems<any>({
        requestFunction: getAllPurchaseOrders,
        pageSize: 500,
        idField: "PurchaseOrderNo",
        requestValues: statusFilter,
        shouldRequest,

    });
    return { rows, status };
}

export const useGetActivePurchaseOrders = (shouldRequest = true) => {
   return useGetAllPurchaseOrders(shouldRequest, "28,29,30,31,32,33");  //Created, Changed, Sent, Confirmed, Shipped, In Progress
}
export const useGetInactivePurchaseOrders = (shouldRequest = true) => {
    return useGetAllPurchaseOrders(shouldRequest, "34,35,36");  //Completed, Received Short, Cancelled
}
export const useLatestPurchaseOrders = (amount = 5) => {
    const { rows, status } = useResponse<any[]>({ requestFunction: getAllPurchaseOrders, values: { amount, pageSize: 1 }, requestNothingOnNull: true });
    return rows;
}



export const useGetAllPurchaseOrderDrafts = () => {
    return useGetAllPaginatedItemsLegacy<SupplierProduct>(getAllPurchaseOrderDrafts, 500, "PurchaseOrderDraftId");
}

export const useGetAllBackorders = () => {
    return useGetAllPaginatedItemsLegacy<any[]>(getAllBackorders, 500, "ArticleNumber");
}
export const useGetPurchaseOrderReferenceData = () => {
    return useResponseLegacy<any>(getPurchaseOrderReferenceData);
}


export const usePurchaseOrderById = (id: string, dependecy = id) => {
    const [response] = useResponseLegacy<any>(getPurchaseOrderById, { id }, true, dependecy);
    return response;
}
export const useProductPurchaseHistory = (productId) => {
    const { rows: result } = useResponse<any[]>({ requestFunction: getProductPurchaseHistory, values: { productId }, requestNothingOnNull: true, dependency: productId });
    // console.log("Purchase History", result, productId);
    return result;
}
export const useGetSupplierProductsBySupplierId = (supplierId: string | number) => {

    const { rows, status } = useGetAllPaginatedItems<any>({
        requestFunction: getSupplierProductsBySupplierId,
        pageSize: 500,
        idField: "SupplierAssortmentItemId",
        requestValues: supplierId,
        shouldRequest: supplierId != null,

    });
    return { rows, status };
}
export const usePurchaseOrderDraftById = (id: string) => {
    const [response] = useResponseLegacy<any[]>(getPurchaseOrderDraftById, { id }, true);
    return response;
}

export const useLowOrderPoints = () => {
    const [response] = useResponseLegacy<any[]>(getLowOrderPoints);
    return response;
}
export const useLowOrderPointsById = (id: string) => {
    const [response] = useResponseLegacy<any[]>(getLowOrderPointsById, { id }, true);
    return response;
}
export const useLowOrderPointsReferenceData = () => {
    return useResponseLegacy<any>(getLowOrderPointsReferenceData);
}



